import { IIconProps } from '~/types';
const AudFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={28} height={20} rx={2} fill="#fff" />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect width={28} height={20} rx={2} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path fill="#0A17A7" d="M0 0h28v20H0z" />
      <path
        d="M0-.333h-.901l.684.586 4.55 3.9v1.009L-.194 8.395l-.14.1v1.44l.51-.319L5.43 6.333h1.13l4.523 3.23a.554.554 0 0 0 .682-.87L7.667 5.18V4.172l4.387-3.134a.67.67 0 0 0 .28-.543V-.6l-.51.318L6.57 3H5.44L.86-.271.772-.333z"
        fill="#FF2E3B"
        stroke="#fff"
        strokeWidth={0.667}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.333V6h4.667v3.333c0 .369.298.667.666.667h1.334a.667.667 0 0 0 .666-.667V6H12a.667.667 0 0 0 .667-.667V4A.667.667 0 0 0 12 3.333H7.333V0H4.667v3.333z"
        fill="url(#b)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4h5.333V0h1.334v4H12v1.333H6.667v4H5.333v-4H0z"
        fill="url(#c)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m6 16.334-1.176.617.225-1.309-.951-.926 1.314-.191L6 13.333l.588 1.19 1.314.192-.95.927.224 1.308zm14 1-.944.276.277-.943-.276-.943.942.276.943-.276-.276.943.276.943zm0-12.667-.944.276.277-.943-.276-.943.942.276.943-.276-.276.943.276.943zm4 4-.944.276.277-.943-.276-.943.942.276.943-.276-.276.943.276.943zM16 10l-.944.276.277-.943-.277-.942.943.276.943-.276-.276.942.276.943zm6 1.667-.47.138.137-.472-.138-.471.472.138.471-.138-.138.471.138.472z"
        fill="#fff"
      />
    </g>
    <defs>
      <linearGradient id="b" x1={0} y1={0} x2={0} y2={10} gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#F0F0F0" />
      </linearGradient>
      <linearGradient id="c" x1={0} y1={0} x2={0} y2={9.333} gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF2E3B" />
        <stop offset={1} stopColor="#FC0D1B" />
      </linearGradient>
    </defs>
  </svg>
);
export default AudFlag;
